import { Trans, useLingui } from '@lingui/react/macro';

import { InputSelect } from '@/design_system/InputSelect/InputSelect';
import InputText from '@/design_system/InputText';
import { useCompanies } from '@/models/company';
import { useInvoiceDestinationName, useUpdateInvoice } from '@/models/invoice';

import { useInvoiceContext } from '../Invoice';

export const InvoiceDestination = () => {
  const { invoice, isDisabled } = useInvoiceContext();

  const recipient = useInvoiceDestinationName(invoice);
  const isInputDisabled = isDisabled || !!invoice.lines.length;

  if (isInputDisabled) {
    return (
      <InputText
        label={<Trans id="invoice.form.destination">Recipient</Trans>}
        value={recipient}
        isDisabled
        style={{ flex: '1 1 200px' }}
      />
    );
  }

  return <InvoiceDestinationSelect />;
};

const InvoiceDestinationSelect = () => {
  const { t } = useLingui();
  const { invoice, showErrors, errors } = useInvoiceContext();
  const { mutate: updateInvoice } = useUpdateInvoice(invoice.id);

  const { data, isFetching } = useCompanies({
    limit: 100,
    traits: ['aftersales', 'store'],
  });

  return (
    <InputSelect
      label={<Trans id="invoice.form.destination">Recipient</Trans>}
      variant="select"
      placeholder={t({
        id: 'accounting.invoices.destination.placeholder',
        message: 'Select the recipient',
      })}
      aria-label={t({ id: 'accounting.invoices.destination.label', message: 'Recipient' })}
      value={invoice.destinationCompany}
      isClearable
      options={data?.companies ?? []}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onChange={(option, action) => {
        if (action.action === 'clear') {
          updateInvoice({
            destinationCompany: null,
          });
        } else if (option) {
          updateInvoice({
            destinationCompany: option,
          });
        }
      }}
      isLoading={isFetching}
      style={{ flex: '1 1 200px' }}
      isInvalid={showErrors && errors.destination}
    />
  );
};
